import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WealthSection from "@/components/WealthSection";
import ConsultationSection from "@/components/ConsultationSection";
import RecruitmentSection from "@/components/RecruitmentSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import useScrollReveal from "@/hooks/useScrollReveal";

export default function Landing() {
  useScrollReveal();
  return (
    <main data-testid="landing-page" className="relative bg-black">
      <Navbar />
      <Hero />
      <WealthSection />
      <ConsultationSection />
      <RecruitmentSection />
      <TestimonialsSection />
      <FAQSection />
      <FinalCTA />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
